import {useSearchParams} from 'react-router'
import TripListing from '@/customComponents/uiComponents/global/TripListing.jsx'
import RideTabNav from '@/customComponents/uiComponents/global/RideTabNav.jsx'
import {useCategoryTrips} from '@/hooks/useTrips'

export default function AllRides() {
    const [searchParams, setSearchParams] = useSearchParams()
    const page = Math.max(1, parseInt(searchParams.get('page'), 10) || 1)
    const setPage = (next) => {
        const params = new URLSearchParams(searchParams)
        if (next > 1) params.set('page', String(next))
        else params.delete('page')
        setSearchParams(params, {replace: true})
    }
    const {data, isLoading, isFetching} = useCategoryTrips('all', {page})

    return (
        <div className="flex flex-col gap-5 max-md:gap-3">
            <h2 className="max-md:hidden">All Rides</h2>
            <RideTabNav/>
            <TripListing
                trips={data?.trips || []}
                heading="All Rides"
                showDark={false}
                rideType="all"
                isLoading={isLoading}
                isFetching={isFetching}
                pagination={data?.pagination}
                page={page}
                onPageChange={setPage}
            />
        </div>
    )
}
